<script>
	import Multiselect from "vue-multiselect";

	export default {
		components: { Multiselect },
		props: {
			value: {
				type: null,
				default: null
			},
			options: {
				type: Array,
				required: true
			},
			placeholder: {
				type: String,
				default: ""
			},
			label: {
				type: String,
				default: "label"
			},
			trackBy: {
				type: String,
				default: "id"
			},
			showLabels: {
				type: Boolean,
				default: false
			},
			allowEmpty: {
				type: Boolean,
				default: true
			},
			searchable: {
				type: Boolean,
				default: false
			},
			multiple: {
				type: Boolean,
				default: false
			},
			max: {
				type: Number,
				default: undefined
			},
			optionHeight: {
				type: Number,
				default: 104
			},
			customClass: {
				type: String,
				default: ""
			}
		},
		computed: {
			computedClass() {
				return `base-multiselect--billing ${this.customClass}`.trim();
			}
		},
		methods: {
			onInput(value) {
				this.$emit("input", value);
			},
			onSelect(option) {
				this.$emit("select", option);
			},
			onRemove(option) {
				this.$emit("remove", option);
			}
		}
	};
</script>

<template>
	<Multiselect
		:value="value"
		:options="options"
		:placeholder="placeholder"
		:label="label"
		:track-by="trackBy"
		:show-labels="showLabels"
		:allow-empty="allowEmpty"
		:searchable="searchable"
		:multiple="multiple"
		:max="max"
		:option-height="optionHeight"
		:class="computedClass"
		@input="onInput"
		@select="onSelect"
		@remove="onRemove"
	>
		<template #noOptions>
			<slot name="noOptions">
				{{ $t("La liste est vide.") }}
			</slot>
		</template>
		<template #maxElements>
			<slot name="maxElements" />
		</template>
	</Multiselect>
</template>

<style lang="scss">
	@import "../../scss/multiselect.scss";

	.base-multiselect--billing {
		.multiselect__placeholder{
			margin-left: 6px;
			white-space: nowrap;
		}
		.multiselect__content-wrapper {
			width: 190px;
		}
		.multiselect__select{
			display: none;
		}
		.multiselect__single{
			font-size: 14px;
			width: 190px;
		}
		.multiselect__tags {
			min-height: 36px;
			padding: 8px 180px 0 8px;
			border-radius: 0;
			background-color: transparent;
			border-left-color: transparent !important;
			border-right-color: transparent !important;
			border-top-color: transparent !important;
			border-bottom: 1px dashed var(--border) !important;
		}

		.multiselect__tags:focus-within,
		.multiselect__tags:focus,
		.multiselect__tags:hover {
			border-left-color: transparent !important;
			border-right-color: transparent !important;
			border-top-color: transparent !important;
			border-bottom: 1px solid var(--text) !important;
		}
	}
</style>
